import React from "react";
// import ProgressBar from "./viewFeedbackProgressBar";
import Modal from "antd/es/modal/Modal";
import Styles from "./styles/viewFeedback.module.scss";

const ViewFeedback = ({
  isModalOpen,
  setIsModalOpen,
  image,
  name,
  designation,
  phone,
  email,
  feedback,
  title
  
}) => {

  return (
    <Modal
      style={{ top:40, right: 0}}
      visible={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      width={589}
      title={<h4 style={{color: 'red'}}>{title}</h4>}
      footer={null}
    >
      <div className={Styles.feedBackContainer}>
        <div className={Styles.userInfoContainer}>
          <img src={image} className={Styles.userImg} alt="" />
          <div className={Styles.infoBox}>
            <b className={Styles.userName}>{name}</b>
            <p className={Styles.designation}>{designation}</p>
            <p className={Styles.contactInfo}>
              {phone} - {email}
            </p>
          </div>
        </div>
        <br />
        <div className={Styles.feedbackInfoContainer} style={{width: '100%'}}>
          <span style={{fontWeight: '700', fontSize: '18px', margin: '0', paddingRight: '10px'}}>Feedback&nbsp;:</span>
          <span className={Styles.feedback}>{feedback || '-'}</span>
        </div>
      </div>
    </Modal>
  );
};

export default ViewFeedback;
